// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HZVB","clinicsSelect":"styles_clinicsSelect__3WItn"};